/**
 * Results
 *
 * View that handles interactions within the results container
 *
 * @return {View}
 */

OT.createNS('OT.Redesign.Views.Results.ResultsContainer');

OT.Redesign.Views.Results.ResultsContainer = OT.Common.Views.Results.ResultsContainer.extend({
    events: function () {
        return _.extend({}, OT.Common.Views.Results.ResultsContainer.prototype.events, {
            'mouseover .rest-name': '',
            'mouseout .rest-name': '',
            'mouseover .rest-row-offer-link': 'createRestaurantModal',
            'mouseover .timeslot': 'createOfferTooltip',
            'mouseout .timeslot': 'removeOfferTooltip',
            'click .timeslot': 'navigateToSlot',
            'click #pop_see_all_link': 'firePopOnlySearch',
            'click .reserve-link': 'createSingleSearchModal',
            'click #availability_link': 'toggleAvailability'
        });
    },

    /**
     * Toggle availability search/no availabilty search
     */
    toggleAvailability: function (e) {
        e.preventDefault();

        OT.Search.Params.set({
            from: null,
            IntersperseAvailability: true
        });

        OT.Search.Requests.Results.get();
    },

    firePopOnlySearch: function () {
        OT.Search.Params.set({
            OnlyPopTimes: true,
            From: null
        });

        $('#Times_onlyPopTimes').attr('checked', true);
        $('[for="Times_onlyPopTimes"]').addClass('highlight');

        OT.Search.Requests.Results.get();

        OT.Search.sendLogRequest('_PopTable', 'interaction', _.extend({
            type: 'see-all-pop-link'
        }, {}));

        return false;
    },

    /**
    * Create restaurant modal delay, view and remove it
    */
    createRestaurantModal: function (e) {
        var self = this;

        if (this.filterModalIsShowing()) {
            return false;
        }

        var $result = $(e.currentTarget);
        var $target = $result.parents('.result');
        var name = $result.hasClass('offer') ? 'offer-name' : 'restaurant-name';
        var rowOffers = $target.data('offers') || '';
        var offerIds = typeof rowOffers === 'number' ? [rowOffers + ''] : rowOffers.split(',');
        var data = _.filter(OT.Search.Data.get().Offers, function (offer) {
                return _.contains(offerIds, offer.Id.toString());
            });

        this.createModalDelay(this.restaurantModalDelay, 'restaurantModal', function () {
            OT.Search.views.restaurantModal.setAttributes({
                $target: $target,
                templateData: data
            }).render();

            var logData = {
                position: $target.data('id') + 1
            };

            if (name === 'offer-name') {
                _.extend(logData, {
                    offerId: e.currentTarget.getAttribute('data-id')
                });
            }

            self.logEvent(e, name + '-hover', logData);
        });
    },

    removeRestaurantModal: function () {
        this.removeModalDelay(this.removeModalDelayTime, 'restaurantModal');
    },

    createSingleSearchModal: function (e) {
        e.preventDefault();

        if (this.filterModalIsShowing()) {
            return false;
        }

        var self = this;
        var $target = $(e.currentTarget);
        var $row = $target.parents('.result');
        var restaurantName = $row.find('.rest-name').text();
        var restaurantId = $row.attr('data-rid');
        var isLunchLink = $target.hasClass('lunch');
        var isDinnerLink = $target.hasClass('dinner');
        var promoId = OT.Search.Params.get('PromoId');
        var ref = OT.Search.Params.get('Ref');
        var profileUrl = $target.attr('data-profile-url');

        this.createModalDelay(0, 'singleSearchModal', function () {
            OT.Search.views.singleSearchModal.display({
                $reserveLink: $target,
                restaurantName: restaurantName,
                restaurantId: restaurantId,
                isLunchLink: isLunchLink,
                isDinnerLink: isDinnerLink,
                promoId: promoId,
                ref: ref,
                profileUrl: profileUrl
            });

            self.logEvent(e, restaurantName + ':single-search-modal', {});
        });
    },

    removeSingleSearchModal: function () {
        this.removeModalDelay(0, 'singleSearchModal');
    },

    /**
     * Create tooltip delay, view and remove it
     */
    createOfferTooltip: function (e) {
        var self = this;
        var $target = $(e.currentTarget);
        var hasPop = $target.data('has-pop') === 'True' || $target.data('has-pop');
        var rowOffers = $target.data('offers') || '';
        var offerIds = typeof rowOffers === 'number' ? [rowOffers + ''] : rowOffers.split(',');
        var offers = _.filter(OT.Search.Data.get().Offers, function (offer) {
            return _.contains(offerIds, offer.Id.toString());
        });
        var data = {
            Offers: _.map(offers, function (offer) {
                return offer.Name;
            })
        };

        if (!OT.Search.Data.get().Display.ShowOffersTooltip) {
            return false;
        }

        if (offerIds[0] !== '' || hasPop === true) {
            if (hasPop === true) {
                data.Offers.push(Resources.Shared.Common.Modals.Offers_PopOfferTitle);
            }

            self.isToolTip = true;
            self.createModalDelay(self.tooltipDelay, 'offerTooltip', function () {
                OT.Search.views.tooltipModal.setAttributes({
                    $target: $target,
                    templateData: data
                });

                if (!OT.Search.views.tooltipModal.$el.is('visible')) {
                    OT.Search.views.tooltipModal.render();
                }

                self.logEvent(e, 'timeslot-hover', {
                    offerIds: ('' + $target.data('offers')).split(','),
                    time: OT.Search.Helpers.convertTimeTo24Hour($target.find('.time').text().trim()),
                    isExact: $target.find('.time').hasClass('exact'),
                    isPop: !!$target.find('.pts').length
                });
            });
        }
    },

    removeOfferTooltip: function () {
        if (this.isToolTip) {
            this.removeModalDelay(this.removeModalDelayTime, 'offerTooltip');
        }

        this.isToolTip = false;
    },

    navigateToSlot: function (e) {
        var isInstantEligible = $(e.target).data('instant-eligible');

        if (!OTSearchData.Experiments.freq963 ||
            !OT.InstantCommon ||
            !Boolean(isInstantEligible)) {
            return true;
        }

        var element = e.target;
        var slotData = {
            rid: element.getAttribute('data-rid'),
            p: element.getAttribute('data-covers'),
            d: element.getAttribute('data-datetime'),
            restaurantName: element.getAttribute('data-name')
        };
        OT.InstantCommon.modal.handleSlotClick(e, { slotData: slotData, src: 'search' });
    },

    logEvent: function (e, type, data) {
        var $target = $(e.currentTarget).parents('.results-set');
        var result = $(e.currentTarget).parents('.result');
        var viewName = '_' + $target.data('name');

        OT.Search.sendLogRequest(viewName, 'interaction', _.extend({
            rid: result.data('rid'),
            type: type,
            hasOffers: !!String(result.data('offers') || '').split(',').length,
            position: result.data('id') + 1
        }, data || {}));
    },

    /**
     * Override these functions so they no longer work.
     * It's easier than removing the events
     */
    createPriceModal: function () { },
    removePriceModal: function () { }
});
